module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "glossary"
    }
  }, [_c('h1', [_vm._v("アイルランドのダンスクラス")]), _vm._v(" "), _c('h2', [_vm._v("お断り")]), _vm._v(" "), _c('span', {
    staticClass: "md-body-1"
  }, [_vm._v("このページはセットダンスをアイルランドで学びたい方向けに、アイルランドのサマースクールやセットダンシングウィーケンドについて城が見聞きしたり調べたものをまとめたものです。情報の正確さなどは保障できません。あくまで渡愛時の参考程度に使用してください。誤りなどありましたら城までご連絡ください。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-card', {
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("ウィリー・クランシー・サマー・スクール（英：Willie Clancy Summer School）")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("開催地：クレア州ミルタウン（英：Miltown, County Clare）")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("開催期間：7月の第一土曜日から約1週間")])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n        クレア州の西海岸ミルタウン・マルベイで開催されるアイルランドで最大規模のサマースクール。開催時期は7月の第一土曜日から約1週間。楽器・ダンスでそれぞれクラスが午前中に開かれる。期間中は1日に2回ケーリーが開かれる。会場はスパニッシュ・ポイント海岸のアルマダ・ホテル（英：Almada Hotel）とミルタウン市街から近いミル・マーキー（英：Mil Marquee）。ミルタウン市街では日中から深夜にかけてセッションも毎夜開かれる。\n      ")]), _vm._v(" "), _c('md-card-header', [_c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Official Website："), _c('a', {
    attrs: {
      "href": "http://www.scoilsamhraidhwillieclancy.com/",
      "target": "_blank"
    }
  }, [_vm._v("http://www.scoilsamhraidhwillieclancy.com/")])]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Facebook Page："), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/willie.clancyweek/",
      "target": "_blank"
    }
  }, [_vm._v("https://www.facebook.com/willie.clancyweek/")])])])], 1), _vm._v(" "), _c('md-card', {
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("サウス・スライゴー・サマースクール（英語：South Sligo Summer School）")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("開催地：スライゴー州タバカリー（英：Tubbercurry, County Sligo）")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("開催期間：Willie Clancy Summer School後の約1週間")])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n        2018年のセットダンス・クラスの講師はPat Murphy。午前中にクラスがあり、地方のセットであるSouth Sligo LancersやTubbercurry Lancersなどが踊られるとか。もちろん夜にはケーリー。\n      ")]), _vm._v(" "), _c('md-card-header', [_c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Official Website："), _c('a', {
    attrs: {
      "href": "http://www.sssschool.org/",
      "target": "_blank"
    }
  }, [_vm._v("http://www.sssschool.org/")])]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Facebook Page："), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/south.sligo.5/",
      "target": "_blank"
    }
  }, [_vm._v("https://www.facebook.com/south.sligo.5/")])])])], 1), _vm._v(" "), _c('md-card', {
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("ジョー・ムーニー・サマー・スクール（英語：Joe Mooney Summer School）")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("開催地：レイトゥリム州ドラムシャンボー（英語：Drumshanbo County Leitrim）")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("開催期間：South Sligo Summer School後の約1週間")])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n\n2018年のセットダンス・クラスの講師はPat MurphyとCatherine Curran。他のサマースクールと同様、午前中にクラス、夜にケーリー。\n      ")]), _vm._v(" "), _c('md-card-header', [_c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Official Website："), _c('a', {
    attrs: {
      "href": "http://joemooneysummerschool.com/",
      "target": "_blank"
    }
  }, [_vm._v("http://joemooneysummerschool.com/")])]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Facebook Page："), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/JoeMooneySummerSchool/",
      "target": "_blank"
    }
  }, [_vm._v("https://www.facebook.com/JoeMooneySummerSchool/")])])])], 1), _vm._v(" "), _c('md-card', {
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("コニー・ライアン・セット・ダンシング・ウィーケンド（英語：Connie Ryan Set Dancing Weekend）")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("開催地：ティペラリー州ネナー（英語：Nenagh, County Tipperary）")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("開催期間：毎年1月中旬の3日間")])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n        Pat Murphyの師であるセット・ダンシング・マスター、Connie Ryanの名を冠したSet Dancing Weekend。近年は中野CCEの方々が毎年行かれているそうです。\n      ")]), _vm._v(" "), _c('md-card-header', [_c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Official Website："), _c('a', {
    attrs: {
      "href": "https://www.abbeycourt.ie/set-dancing-weekend.html",
      "target": "_blank"
    }
  }, [_vm._v("https://www.abbeycourt.ie/set-dancing-weekend.html")])])])], 1), _vm._v(" "), _c('md-card', {
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("コニー・ライアン・ダブリン・ダンシング（英語： Connie Ryan Dublin Dancing）")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("開催地：ダブリン州ダブリン（英語：Dublin, County Dublin）")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("開催期間：1月中旬の3日間")])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n        同じくConnie Ryanの名を冠したSet Dancing Weekend。Connie Ryan主催で1980年初頭に始まり、彼の死後も現在に至るまで続いている。「コニー・ライアンを偲ぶ会」とも呼ばれる。2018年を除いて毎年開催。コニー・ライアンに縁のある人やバンドが集まる。マラハイドのGrand Hotel、Red Cow Moran Hotelから会場を移し、2019年はGreen Isle Hotelで開催された。オールド・ステップやシャンノース、セットダンスなど6つのワークショップと4回のケーリー。スムース・ステップが上手い人が集うという噂も。\n      ")]), _vm._v(" "), _c('md-card-header', [_c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Facebook Page："), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/events/393225507753248/",
      "target": "_blank"
    }
  }, [_vm._v("https://www.facebook.com/events/393225507753248/")])])])], 1), _vm._v(" "), _c('md-divider'), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("copyright © 2017-" + _vm._s(new Date().getFullYear()) + " Hiroshi Jo")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2f9527e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EventOfIreland.vue
// module id = 342
// module chunks = 1